function origemDoSocket(urlBackend) {
  const url = `${urlBackend || ''}`;
  return url.replace(/\/api\/?$/, '').replace(/\/$/, '');
}

export default {
  urlBaseSocket: origemDoSocket(process.env.VUE_APP_ADDRESS_BACKEND),
  urlBaseSocket_dev: 'http://localhost:8000',
  IS_DEV: false
};
